import {
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummaryProps,
  Stack,
  styled,
  TypographyProps,
} from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiTypography from '@mui/material/Typography';
import React from 'react';

export const FormGroup = styled(Stack)<{ gapsize: 's' | 'm' }>`
  gap: ${({ gapsize }) => (gapsize === 's' ? '8px' : '12px')};
`;

export const FormConfig = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters {...props} />
))(() => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  margin: '80px 0 0',
  '&:before': {
    display: 'none',
  },
  '&.MuiAccordion-root': {
    padding: 0,
    border: 'none',
  },
}));

export const FormConfigHeader = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(() => ({
  backgroundColor: 'transparent',
  padding: 0,
  minHeight: 'auto',
  '&.MuiAccordionSummary-root': {
    margin: 0,
    borderBottom: '1px solid #000',
    paddingBottom: '12px',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    color: 'var(--dk-text, #000)',
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '40px',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    padding: 0,
  },
}));

export const FormConfigHeaderTitle = styled((props: TypographyProps) => (
  <MuiTypography {...props} />
))(() => ({
  color: 'var(--dk-text, #000)',
  fontSize: '28px',
  fontWeight: 500,
  lineHeight: '40px',
}));

export const FormConfigBody = styled((props: AccordionDetailsProps) => (
  <MuiAccordionDetails {...props} />
))(() => ({
  margin: '40px 0',
  '&.MuiAccordionDetails-root': {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  },
}));
